<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card h-100" style="height: 100vh">
          <div class="d-flex justify-content-between">
            <h4 slot="header" class="card-title">Pesquisas da Campanha</h4>
            <div class="d-flex align-items-center">
              <button v-if="campaignOrder.length > 0" class="btn btn-primary btn-sm" @click="saveOrder(campaignOrder)">Salvar ordem</button>
              &nbsp;
              <button class="btn btn-info btn-sm" @click="visibilityStates.createVisibility = true">Adicionar Pesquisa</button>
            </div>
          </div>

          <div class="d-flex" v-if="isGridMounted">
            <div class="campaign__grid overflow-auto" style="height: 78vh; overflow-y: auto">
              <div class="grid__column">
                <muuri-grid :options="options" @layoutEnd="updateOrder">
                  <div class="campaign__item" v-for="item in orderedSurvey" :key="item.id" :id="item.id">
                    <div class="campaign__details">
                      <div class="campaign__name">{{ item.id }}</div>
                      <div class="campaign__name" v-if="item.question">
                        {{ item.question.type }}:
                        {{ getQuestionDetail(item.question) }}
                      </div>
                      <div v-if="item.question" class="campaign__name">tipo: {{ item.question.type }}</div>
                    </div>
                  </div>
                </muuri-grid>
              </div>
            </div>
          </div>

          <Empty v-if="surveys.length === 0"></Empty>
        </card>
      </div>
    </div>

    <!-- Modal Add -->
    <Modal v-model="visibilityStates.createVisibility" successMessage="Pesquisa adicionada com sucesso!" action="Adicionar" title="Adicionar pesquisa" @closeModal="clearFieldsAddModal()" @confirmAction="addQuestion(questionId)">
      <template v-slot:body>
        <div class="form-group">
          <label>Selecione a pergunta</label>
          <treeselect v-model="questionId" :multiple="false" :options="filteredQuestions" :flat="false" :normalizer="normalizer" />
        </div>

        <div class="d-flex align-items-center mb-2">
          <div class="form-check">
            <label for="addInsideCampaign" class="form-check-label">
              <input id="addInsideCampaign" class="form-check-input" type="checkbox" v-model="addInsideCampaign" />
              <span class="form-check-sign"></span>
              <span>Adicionar em uma campanha</span>
            </label>
          </div>
        </div>

        <div v-if="addInsideCampaign" class="form-group">
          <label>Selecione a campanha</label>
          <treeselect v-model="campaignIds" :multiple="true" :options="allCampaigns" :flat="false" :normalizer="normalizeCampaigns" />
        </div>
      </template>
    </Modal>

    <!-- Modal Delete -->
    <Modal v-model="visibilityStates.deleteVisibility" successMessage="Pesquisa excluída com sucesso!" action="Sim" :name="className" title="Remover pesquisa" @closeModal="visibilityStates.deleteVisibility = false" @confirmAction="deleteQuestion">
      <template v-slot:body>
        <p>Tem certeza que deseja remover a pesquisa da campanha?</p>
      </template>
    </Modal>
  </div>
</template>
<script>
import { ItemLink, ItemSm, ItemMd, ItemLg } from 'vue-muuri';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Modal from '@/components/Modal/Modal';
import Pagination from '@/components/Pagination/Pagination';
import Empty from '@/components/Common/Empty';
import api from '@/api.js';
export default {
  components: {
    Modal,
    Pagination,
    Empty,
    Treeselect,
    ItemLink,
    ItemSm,
    ItemMd,
    ItemLg,
  },
  data() {
    return {
      visibilityStates: {
        createVisibility: false,
        deleteVisibility: false,
      },
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false,
      },
      options: {
        items: '.campaign__item',
        dragEnabled: true,
      },

      // Questions Params
      selectedQuestions: [],

      // Pagination Params
      currentPage: 1,
      total: 0,
      totalPages: 0,
      itemCount: 0,

      // Loader
      loading: false,
      error: false,

      // Campaign Params
      campaigns: [],
      campaignName: '',
      campaignOrder: [],

      // Surveys
      surveys: [],

      // Questions
      questionId: null,
      questionLastOrder: null,

      isGridMounted: false,

      brands: [],
      selectedBrands: [],
      tips: [],
      selectedTips: [],

      data: [],
      deleteVisibility: false,
      editVisibility: false,
      createVisibility: false,
      classId: '',
      className: '',

      // Modal Adicionar Pesquisa
      surveyType: '',

      addInsideCampaign: false,
      allCampaigns: [],
      campaignIds: null,
    };
  },
  computed: {
    orderedSurvey() {
      const sortedSurvey = this.surveys;
      return sortedSurvey.sort((a, b) => (a.order > b.order ? 1 : -1));
    },
    questions() {
      return this.$store.getters['questions/getAllQuestions'];
    },
    filteredQuestions() {
      // Eu quero os questions que não estão inclusos nos surveys
      if (this.orderedSurvey.length > 0 && this.questions.length > 0) {
        return this.questions.filter((s) => !this.orderedSurvey.map((a) => a.questionId).includes(s.id));
      }
    },
    surveyExists() {
      if (this.orderedSurvey.find((s) => s.questionId === this.questionId)) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    getQuestionDetail(question) {
      if (question.type === 'profile' && !question.profile) {
        return question.typeResponse;
      }
      if (question.type === 'profile' && question.profile) {
        return question.profile.slug;
      }
      if (question.type === 'brand') {
        return question.brands.name;
      }
      if (question.type === 'trick') {
        return question.brands.name;
      }
    },
    normalizeCampaigns(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    normalizer(node) {
      let fixedLabel;
      if (node.type === 'profile' && !node.profile) {
        fixedLabel = node.typeResponse;
      }
      if (node.type === 'profile' && node.profile) {
        fixedLabel = node.profile.slug;
      }
      if (node.type === 'brand') {
        fixedLabel = node.brands.name;
      }

      if (node.type === 'trick') {
        fixedLabel = node.brands.name;
      }

      return {
        id: node.id,
        label: fixedLabel,
      };
    },
    notifyVue(verticalAlign, horizontalAlign) {
      const color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        icon: 'tim-icons icon-bell-55',
        type: 'success',
        timeout: 3000,
        message: 'Ordem salva com sucesso',
      });
    },
    saveOrder: async function (campaignOrder) {
      await api.put(`/surveys/updateorder`, campaignOrder);
      this.getCampaignById(this.$route.params.id);
      this.notifyVue('top', 'center');
    },
    getAllCampaigns: async function () {
      const { data } = await api.get(`/campaigns`);
      this.allCampaigns = data.filter((s) => s.status === 'asked');
    },
    /** Pega as perguntas referentes a campanha atual */
    getCampaignById: async function (id) {
      this.isGridMounted = false;
      const { data } = await api.get(`/surveys`);
      this.surveys = data;
      this.selectedQuestions = data.map((s) => ({
        id: s.surveyId,
        label: s.name,
      }));
      if (data.length > 0) {
        this.questionLastOrder = data.length;
      } else {
        this.questionLastOrder = 0;
      }
      this.isGridMounted = true;
    },
    updateOrder(items) {
      this.campaignOrder = items.map((s, i) => ({
        id: Number(s._element.id),
        order: i,
      }));
    },
    loadBrands: async function () {
      const res = await api.get(`/brands`);
      this.brands = res.data.items;
    },
    addBrand2Campaign: async function (surveyId) {
      let params = {};
      params.campaignIds = this.campaignIds;
      params.surveyId = surveyId;

      try {
        const res = await api.put(`campaigns/asked`, params);
      } catch (error) {
        this.$notify({
          icon: 'tim-icons icon-bell-55',
          type: 'danger',
          timeout: 3000,
          message: 'Erro: A pesquisa já está na campanha',
        });
      }
    },
    addQuestion: async function (question) {
      // Criar survey caso ele não exista
      if (!this.surveyExists) {
        try {
          let params = {};
          params.order = this.questionLastOrder;
          params.questionId = question;
          const { data } = await api.post(`surveys`, params);
          if (this.addInsideCampaign) {
            this.addBrand2Campaign(data.id);
          }
          this.$notify({
            icon: 'tim-icons icon-bell-55',
            type: 'success',
            timeout: 3000,
            message: 'Pesquisa adicionada com sucesso',
          });
        } catch (error) {
          this.$notify({
            icon: 'tim-icons icon-bell-55',
            type: 'danger',
            timeout: 3000,
            message: 'Erro: A pesquisa já está na campanha',
          });
        }
      } else {
        this.$notify({
          icon: 'tim-icons icon-bell-55',
          type: 'danger',
          timeout: 3000,
          message: 'Erro: A pesquisa já está na campanha',
        });
      }
      this.questionId = null;
      this.addInsideCampaign = false;
      this.campaignIds = null;

      this.$store.dispatch('questions/getQuestionsNoLimit');
      this.getCampaignById(this.$route.params.id);
      this.getAllCampaigns();
    },
    openCreateModal: function () {
      this.questionId = null;
      this.createVisibility = true;
    },
    openDeleteModal: function (id) {
      this.visibilityStates.deleteVisibility = true;
      this.questionId = id;
    },
    deleteQuestion: async function () {
      const res = await api.delete(`surveys/${this.questionId}`);
      this.visibilityStates.deleteVisibility = false;
      this.getCampaignById(this.$route.params.id);
      this.$notify({
        icon: 'tim-icons icon-bell-55',
        type: 'success',
        timeout: 3000,
        message: 'Pesquisa removida com sucesso',
      });
    },
    showAddModal: async function () {
      this.addModal = true;
    },
    showDeleteModal: function (id, name) {
      this.deleteModal = true;
      this.activeBrandId = id;
      this.activeBrandName = name;
    },
    clearFieldsAddModal() {
      this.visibilityStates.createVisibility = false;
      this.campaignIds = null;
      this.questionId = null;
      this.addInsideCampaign = false;
    },
  },
  mounted() {
    this.$store.dispatch('questions/getQuestionsNoLimit');
    this.getCampaignById(this.$route.params.id);
    this.getAllCampaigns();
  },
};
</script>
<style>
.campaign__grid {
  width: 100%;
  position: relative;
  margin: 0 auto;
}

.item {
  position: absolute !important;
  width: 100% !important;
  margin: 5px 0 !important;
}
.grid__column {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  background: #27293d;
  border-radius: 3px;
  z-index: 1;
}
.campaign__item {
  position: absolute;
  width: 100%;
  margin: 5px 0;
  border: 1px solid grey;
  height: 55px;
  display: flex;
  align-items: center;
}
.campaign__name {
  display: flex;
  align-items: center;
  height: 55px;
  color: #fff;
}
.campaign__details {
  display: grid;
  grid-gap: 24px;
  grid-template-columns: 20px 1fr 1fr 50px;
  padding: 0 20px;
  cursor: grab;
}
.campaign__column__content {
  position: relative;
  border: 10px solid transparent;
  min-height: 95px;
}
select option {
  color: #039be5;
}
</style>
